import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/TagsService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../store/RecordsSliceCaseHelpers';
import {Tag} from '../types';

import {recordSelector} from "../selectors";

const entityKey = 'tags';

interface TagState {
    byId: { [key: string]: Tag },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as TagState;


const normalizeRecord = (record: Tag) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchTags = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    () => {
        const filter = {}
        return fetchRecords(filter)
            .then((response) => {
                if (response && response.items) {
                    return response.items.map((record: Tag) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchTag = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const saveTag = createAsyncThunk(
    `${entityKey}/add`,
    (payload: Tag) => {
        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateTag = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: Tag }) => {

        const modified = {
            id: record.id,
            description: record.description,
        }

        return update(id, modified)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    },
);

export const deleteTag = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string, {getState}) => {

        const state = getState();
        const {record} = recordSelector(state, id);

        return deleteRecord(id, record.name)
            .then(() => id);
    },
);


export const storeTag = createAsyncThunk(
    `${entityKey}/store`,
    (payload: Tag) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchTags, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchTag);

                                            // SAVE ONE
                                            saveOneCase(builder, saveTag);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateTag);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteTag);
                                        },
                                    });

export default componentsSlice.reducer;
